import { render, staticRenderFns } from "./appointment-two.vue?vue&type=template&id=d080c750&scoped=true"
import script from "./appointment-two.vue?vue&type=script&lang=js"
export * from "./appointment-two.vue?vue&type=script&lang=js"
import style0 from "./appointment-two.vue?vue&type=style&index=0&id=d080c750&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d080c750",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d080c750')) {
      api.createRecord('d080c750', component.options)
    } else {
      api.reload('d080c750', component.options)
    }
    module.hot.accept("./appointment-two.vue?vue&type=template&id=d080c750&scoped=true", function () {
      api.rerender('d080c750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/softBusinessLogistics/appointment-two.vue"
export default component.exports